/**
 * Reading the API's per-sport prices (`[{ sport, annualPriceCents }]`) through guards rather than a
 * cast. No imports beyond types, so the anonymous services (setup invitations) can use it without
 * pulling in the authenticated API client.
 */

import type { SignupSport, SportPrice } from '../types/signup';

export const isSport = (value: unknown): value is SignupSport =>
  value === 'baseball' || value === 'softball';

const isPriceCents = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0;

/** Each well-formed `{ sport, annualPriceCents }`, for one of `sports`, once. Anything else is dropped. */
export const parseSportPrices = (value: unknown, sports: readonly SignupSport[]): SportPrice[] => {
  if (!Array.isArray(value)) return [];
  const prices: SportPrice[] = [];
  for (const entry of value) {
    if (typeof entry !== 'object' || entry === null) continue;
    const { sport, annualPriceCents } = entry as Record<string, unknown>;
    if (!isSport(sport) || !sports.includes(sport) || !isPriceCents(annualPriceCents)) continue;
    if (prices.some((price) => price.sport === sport)) continue;
    prices.push({ sport, annualPriceCents });
  }
  return prices;
};
